import React from "react";
import { Link } from "react-router-dom";

interface ILinkButton {
    children?: React.ReactNode;
    href: string;
    target?: string;
    className?: string;
}

const LinkButton: React.FC<ILinkButton> = ({
    children,
    href,
    target = '_self',
    className
}) => {
    return (
        <Link to={href} target={target} className={"select-none inline-block bg-red hover:opacity-80 text-[15px] uppercase leading-[18px] font-semibold text-white py-[9px] px-[18px] rounded-[4px]" + (!!className ? (" " + className) : "")}>
            {children}
        </Link>
    );
}

export default LinkButton;